export default {"src":"/_next/static/media/Error.ff5ef9c7.svg","height":20,"width":20};